<script lang="ts">
    import { createBufferFromPattern, createBufferSource } from './../audio/buffer-generator';
    import audioCtx from './../audio/context';    
    import volumeController from './../audio/volume-controller';

    import type { Beat, CalculatedInfo, Sample } from './../samples';
    import type Pattern from './../pattern/pattern';
    
    let beat: Beat;
    let calculatedInfo: CalculatedInfo;

    let bufferSourceBeat: AudioBufferSourceNode;
    let audioBufferSampleCombined: AudioBuffer, bufferSourceSampleCombined: AudioBufferSourceNode;

    export const initialize = async (
        pattern: Pattern, 
        _beat: Beat, 
        sample: Sample,
        _calculatedInfo: CalculatedInfo
    ) => {
        beat = _beat;
        calculatedInfo = _calculatedInfo;

        audioBufferSampleCombined = await createBufferFromPattern(
            pattern,
            sample.audioBuffer,
            calculatedInfo.durationPerBar
        );       
    };

    export const startPlaying = () => {
      let now = audioCtx.currentTime + 0.1;
      startPlayingSample(now);
      startPlayingBeat(now);
    };
    const startPlayingBeat = (now: number) => {
      bufferSourceBeat = createBufferSource(
        beat.audioBuffer, 
        $volumeController.gainNodeBeat
      );
      bufferSourceBeat.playbackRate.value = calculatedInfo.playbackRate;
      bufferSourceBeat.start(now);
    };
    const startPlayingSample = (now: number) => {
      bufferSourceSampleCombined = createBufferSource(
        audioBufferSampleCombined, 
        $volumeController.gainNodeSample
      );
      bufferSourceSampleCombined.start(now);
    };

    export const stopPlaying = () => {
      bufferSourceBeat.stop(0);
      bufferSourceSampleCombined.stop(0);
    };

    export const updatePlaybackRate = (playbackRate: number) => {
      bufferSourceBeat.playbackRate.value = playbackRate;
      bufferSourceSampleCombined.playbackRate.value = playbackRate;
    };

</script>